import { ReactElement, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { EEinvoicingStatus, TInvoiceEinvoiceLinkEnriched } from '@Arti-zen/package-backoffice'
import { ApiArtizenBO } from 'utils/artizenConnector'
import TableInfinite from 'components/table/infinite/InfiniteTable'
import { definitionFields } from './EinvoicingTable.definitionFields'
import DownloadButton from 'components/DownloadButton'
import { Dialog, FormControl, Input, InputLabel, MenuItem, Select } from '@mui/material'
import { EinvoivingError } from './Einvoiving.error'
import { DateTime } from 'luxon'

export default function EinvoicingWeeklyCtrl(): ReactElement {
  const [eInvoiceList, setEInvoiceList] = useState<TInvoiceEinvoiceLinkEnriched[]>([])
  const [itemSelected, setItemSelected] = useState<TInvoiceEinvoiceLinkEnriched | null>(null)
  const [weekNumberSelected, setWeekNumberSelected] = useState<number>(DateTime.now().weekNumber)

  const { nb, nbOk, nbTested } = useMemo(() => {
    return {
      nb: eInvoiceList.length,
      nbTested: eInvoiceList.filter((f) => f.state !== EEinvoicingStatus.TEST_COMPANY_NOT_READY).length,
      nbOk: eInvoiceList.filter((f) => f.state === EEinvoicingStatus.TEST_SUCCESS).length,
    }
  }, [eInvoiceList])

  useEffect(() => {
    ApiArtizenBO.eInvoicing
      .getAllByWeek({ year: 2026, week: weekNumberSelected })
      .then(setEInvoiceList)
      .catch(console.error)
  }, [weekNumberSelected])

  const onSelectWeek = (weekNumber: number) => {
    setWeekNumberSelected(weekNumber)
  }

  const onSelect = (item: TInvoiceEinvoiceLinkEnriched) => {
    setItemSelected(item)
  }

  return (
    <Wrapper>
      <Header>
        <FormControl>
          <InputLabel id="week">Semaine</InputLabel>
          <Select
            labelId="week"
            label="Semaine"
            id="weekNumber"
            size="small"
            value={weekNumberSelected}
            onChange={(e) => onSelectWeek(Number(e.target.value))}
          >
            {[...Array(52)].map((_, i) => (
              <MenuItem key={i + 1} value={i + 1}>
                <b>{i + 1}</b> -{' '}
                {DateTime.now()
                  .set({ weekNumber: i + 1 })
                  .startOf('week')
                  .toFormat('dd/MM/yyyy')}{' '}
                au{' '}
                {DateTime.now()
                  .set({ weekNumber: i + 1 })
                  .endOf('week')
                  .toFormat('dd/MM/yyyy')}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <StatsWrapper>
          <table>
            <tbody>
              <tr>
                <StatsLabel>Nb factures</StatsLabel>
                <StatsValue>{nb}</StatsValue>
              </tr>
              <tr>
                <StatsLabel>Nb factures TESTEES</StatsLabel>
                <StatsValue>{nbTested}</StatsValue>
                <StatsValue>{((nbTested * 100) / nb).toFixed(2)}%</StatsValue>
              </tr>
              <tr>
                <StatsLabel>Nb factures OK</StatsLabel>
                <StatsValue>{nbOk}</StatsValue>
                <StatsValue>{((nbOk * 100) / nbTested).toFixed(2)}%</StatsValue>(des factures testées)
              </tr>
            </tbody>
          </table>
        </StatsWrapper>
        <DownloadButton data={eInvoiceList} fileName="eInvoices" label={null} size="medium" />
      </Header>
      <TableInfinite<TInvoiceEinvoiceLinkEnriched>
        data={eInvoiceList}
        definitionFields={definitionFields({ onSelect })}
        nextPage={null}
        isQueriedAllCompleted={true}
      />

      {itemSelected && (
        <Dialog open={!!itemSelected} onClose={() => setItemSelected(null)} maxWidth="xl">
          <EinvoivingError
            open={!!itemSelected}
            results={JSON.parse(itemSelected.error)}
            onClose={() => setItemSelected(null)}
            invoiceId={Number(itemSelected.invoiceId)}
          />
        </Dialog>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 100px;
  margin-bottom: 20px;
`

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const StatsLabel = styled.td`
  padding-right: 15px;
`
const StatsValue = styled.td`
  font-weight: bold;
  text-align: center;
  background-color: lightgray;
  border-radius: 5px;
  padding: 2px;
  padding-left: 10px;
  padding-right: 10px;
`